import React, { useEffect } from "react";

const AdComponent = () => {
  useEffect(() => {
    // Somente executa o push se o AdSense estiver carregado
    if (typeof window.adsbygoogle !== "undefined" && window.adsbygoogle.push) {
      try {
        window.adsbygoogle.push({});
      } catch (e) {
        console.error("Erro ao carregar o anúncio:", e);
      }
    }
  }, []);

  return (
    <ins className="adsbygoogle"
         style={{ display: 'block' }}
         data-ad-client="ca-pub-3458489837498636"
         data-ad-slot="7646400856"  // Substitua pelo seu código de slot
         data-ad-format="auto"
         data-full-width-responsive="true"></ins>
  );
};

export default AdComponent;
